import SidebarImage from './sidebar.png';

export const sidebarPhoto = () => SidebarImage;
